//src/pages/ReadabilityTools/tabs/TextLookupTab/index.js


//src/pages/ReadabilityTools/tabs/TextLookupTab/index.js

import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
  alpha
} from '@mui/material';
import {
  Search as SearchIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useTextLookup } from './useTextLookup';
import TranslationInput from '../TextTranslationTab/TranslationInput';
import LookupResults from './LookupResults';

const TextLookupTab = () => {
  const theme = useTheme();
  const {
    inputText,
    lookupResult,
    loading,
    error,
    handleInputChange,
    clearInput,
    lookupText,
    copyToClipboard,
    canLookup,
    hasResults
  } = useTextLookup();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Readable English Translation Lookup
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Enter text below to get a detailed word-by-word breakdown with Readable English translations and glyphs.
      </Typography>

      <TranslationInput
        value={inputText}
        onChange={handleInputChange}
        onClear={clearInput}
        placeholder="Enter text to look up..."
      />

      {error && (
        <Alert 
          severity="error" 
          sx={{ 
            mb: 3, 
            bgcolor: alpha(theme.palette.error.main, 0.1),
            color: theme.palette.error.main
          }}
        >
          {error}
        </Alert>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SearchIcon />}
          onClick={lookupText}
          disabled={!canLookup}
        >
          {loading ? 'Looking up...' : 'Lookup Text'}
        </Button>
      </Box>

      {hasResults && (
        <LookupResults 
          lookupResult={lookupResult}
          inputText={inputText}
          onCopy={copyToClipboard}
        />
      )}
    </Box>
  );
};

export default TextLookupTab;



// import { useState } from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Divider,
//   Card,
//   CardContent,
//   alpha,
//   IconButton,
//   CircularProgress,
//   Alert,
//   Chip
// } from '@mui/material';
// import {
//   Search as SearchIcon,
//   ContentCopy as CopyIcon,
//   Clear as ClearIcon
// } from '@mui/icons-material';
// import { useTheme } from '@mui/material/styles';
// import { readabilityService } from '../../../../services/readability-service';

// const TextLookupTab = () => {
//   const theme = useTheme();
//   const [inputText, setInputText] = useState('');
//   const [lookupResult, setLookupResult] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [snackbarMessage, setSnackbarMessage] = useState('');

//   const handleInputChange = (e) => {
//     setInputText(e.target.value);
//   };

//   const handleClearInput = () => {
//     setInputText('');
//     setLookupResult(null);
//     setError(null);
//   };

//   const lookupText = async () => {
//     if (!inputText.trim()) {
//       setError('Please enter some text to lookup');
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       const response = await readabilityService.lookup({text:inputText})
//       setLookupResult(response);
//     } catch (err) {
//       console.error('Lookup error:', err);
//       setError('Error looking up text. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCopyToClipboard = (text) => {
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         setSnackbarMessage('Copied to clipboard');
//       })
//       .catch(err => {
//         console.error('Could not copy text: ', err);
//         setSnackbarMessage('Failed to copy to clipboard');
//       });
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h6" gutterBottom>
//         Readable English Translation Lookup
//       </Typography>
//       <Typography variant="body2" color="text.secondary" paragraph>
//         Enter text below to get a detailed word-by-word breakdown with Readable English translations and glyphs.
//       </Typography>

//       <Box sx={{ position: 'relative', mb: 3 }}>
//         <TextField
//           fullWidth
//           multiline
//           rows={4}
//           placeholder="Enter text to look up..."
//           value={inputText}
//           onChange={handleInputChange}
//           variant="outlined"
//           sx={{
//             bgcolor: alpha(theme.palette.background.card, 0.6),
//             '& .MuiOutlinedInput-root': {
//               '& fieldset': {
//                 borderColor: alpha(theme.palette.common.white, 0.2),
//               },
//               '&:hover fieldset': {
//                 borderColor: alpha(theme.palette.primary.main, 0.5),
//               },
//               '&.Mui-focused fieldset': {
//                 borderColor: theme.palette.primary.main,
//               }
//             }
//           }}
//         />
//         {inputText && (
//           <IconButton 
//             sx={{ 
//               position: 'absolute', 
//               right: 8, 
//               top: 8, 
//               color: theme.palette.text.secondary 
//             }}
//             onClick={handleClearInput}
//           >
//             <ClearIcon />
//           </IconButton>
//         )}
//       </Box>

//       {error && (
//         <Alert 
//           severity="error" 
//           sx={{ 
//             mb: 3, 
//             bgcolor: alpha(theme.palette.error.main, 0.1),
//             color: theme.palette.error.main
//           }}
//         >
//           {error}
//         </Alert>
//       )}

//       <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
//         <Button
//           variant="contained"
//           color="primary"
//           size="large"
//           startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SearchIcon />}
//           onClick={lookupText}
//           disabled={loading || !inputText.trim()}
//         >
//           {loading ? 'Looking up...' : 'Lookup Text'}
//         </Button>
//       </Box>

//       {lookupResult && (
//         <Box sx={{ mt: 4 }}>
//           <Divider sx={{ mb: 3, borderColor: alpha(theme.palette.common.white, 0.1) }} />
          
//           <Typography variant="h6" gutterBottom>
//             Text Analysis Results
//           </Typography>

//           <Card 
//             variant="outlined" 
//             sx={{ 
//               mb: 3, 
//               bgcolor: theme.palette.background.card,
//               borderColor: alpha(theme.palette.common.white, 0.1)
//             }}
//           >
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                 <Typography variant="subtitle2" color="primary">
//                   Original Text
//                 </Typography>
//                 <IconButton 
//                   size="small" 
//                   onClick={() => handleCopyToClipboard(inputText)}
//                   sx={{ color: theme.palette.text.secondary }}
//                 >
//                   <CopyIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//               <Typography variant="body1" paragraph>
//                 {inputText}
//               </Typography>

//               <Divider sx={{ my: 2, borderColor: alpha(theme.palette.common.white, 0.1) }} />
              
//               <Typography variant="subtitle2" color="primary" gutterBottom>
//                 Word Lookup Results
//               </Typography>

//               <Box sx={{ mt: 2, mb: 2 }}>
//                 <Typography variant="body2" gutterBottom>
//                   <strong>Words Found:</strong> {lookupResult.wordsFound.length}
//                 </Typography>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
//                   {lookupResult.wordsFound.map((word, index) => (
//                     <Chip
//                       key={index}
//                       label={word}
//                       size="small"
//                       sx={{
//                         bgcolor: alpha(theme.palette.success.main, 0.1),
//                         color: theme.palette.success.main,
//                         borderColor: alpha(theme.palette.success.main, 0.3),
//                         fontWeight: 500,
//                         fontSize: '0.75rem'
//                       }}
//                     />
//                   ))}
//                 </Box>

//                 <Typography variant="body2" gutterBottom>
//                   <strong>Words Not Found:</strong> {lookupResult.wordsNotFound.length}
//                 </Typography>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
//                   {lookupResult.wordsNotFound.length > 0 ? (
//                     lookupResult.wordsNotFound.map((word, index) => (
//                       <Chip
//                         key={index}
//                         label={word}
//                         size="small"
//                         sx={{
//                           bgcolor: alpha(theme.palette.error.main, 0.1),
//                           color: theme.palette.error.main,
//                           borderColor: alpha(theme.palette.error.main, 0.3),
//                           fontWeight: 500,
//                           fontSize: '0.75rem'
//                         }}
//                       />
//                     ))
//                   ) : (
//                     <Typography variant="body2" color="text.secondary">
//                       None
//                     </Typography>
//                   )}
//                 </Box>

//                 <Typography variant="body2" gutterBottom>
//                   <strong>Non-Words Found:</strong> {lookupResult.nonWordsFound.length}
//                 </Typography>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                   {lookupResult.nonWordsFound.map((nonWord, index) => (
//                     <Chip
//                       key={index}
//                       label={nonWord === ' ' ? 'Space' : nonWord}
//                       size="small"
//                       sx={{
//                         bgcolor: alpha(theme.palette.info.main, 0.1),
//                         color: theme.palette.info.main,
//                         borderColor: alpha(theme.palette.info.main, 0.3),
//                         fontWeight: 500,
//                         fontSize: '0.75rem'
//                       }}
//                     />
//                   ))}
//                 </Box>
//               </Box>
//             </CardContent>
//           </Card>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default TextLookupTab;